import { CSSObject } from "styled-components";

//App
import { vfxTheme } from "../VFX-UI/Theme/theme";

interface DisplayDataStyles {
  bold: CSSObject;
  label: CSSObject;
  data: CSSObject;
  flex: CSSObject;
}

const useDisplayDataStyles = (): DisplayDataStyles => {
  
  return {
    bold: {
      fontWeight: vfxTheme.fontWeights.bold,
    },
    label: {
      fontSize: vfxTheme.spaceUnits.sp03,
      //paddingBottom: vfxTheme.spaceUnits.sp01,
      paddingRight: vfxTheme.spaceUnits.sp01,
        whiteSpace: "normal",
      textWrap:"nowrap"
    },
    data: {
      //paddingBottom: vfxTheme.spaceUnits.sp03,
        whiteSpace: "normal",
        textWrap: "pretty"
    },
    flex: {
      display: "flex",
    },
  };
};

export default useDisplayDataStyles;
